import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-traval-contractlist',
  templateUrl: './traval-contractlist.component.html',
  styleUrls: ['./traval-contractlist.component.scss']
})
export class TravalContractlistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
